import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';

// "← Volver" a la pantalla anterior; si hay cambios sin guardar pide confirmación
export const BackButton = ({ dirty = false, fallback = '/dashboard', className = '', label = 'Volver' }) => {
  const navigate = useNavigate();
  const [ask, setAsk] = useState(false);
  const [pendingHref, setPendingHref] = useState(null);
  useEffect(() => {
    if (!dirty) return;
    const warn = (e) => { e.preventDefault(); e.returnValue = ''; };
    // Links del menú (sidebar) también piden confirmación
    const onLink = (e) => {
      const a = e.target.closest?.('a[href]');
      if (!a || a.target === '_blank' || a.origin !== window.location.origin || a.pathname === window.location.pathname) return;
      e.preventDefault(); e.stopPropagation();
      setPendingHref(a.pathname + a.search); setAsk(true);
    };
    window.addEventListener('beforeunload', warn);
    document.addEventListener('click', onLink, true);
    return () => { window.removeEventListener('beforeunload', warn); document.removeEventListener('click', onLink, true); };
  }, [dirty]);
  const back = () => (window.history.state?.idx > 0 ? navigate(-1) : navigate(fallback));
  const go = () => (pendingHref ? navigate(pendingHref) : back());
  return (
    <>
      <Button variant="ghost" className={`gap-1.5 ${className}`} onClick={() => { if (!dirty) return back(); setPendingHref(null); setAsk(true); }} data-testid="back-btn-generic">
        <ArrowLeft className="w-4 h-4" />{label}
      </Button>
      <AlertDialog open={ask} onOpenChange={setAsk}>
        <AlertDialogContent data-testid="unsaved-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Tenés cambios sin guardar</AlertDialogTitle>
            <AlertDialogDescription>Si salís ahora se pierden. ¿Querés salir igual?</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="unsaved-stay">Seguir editando</AlertDialogCancel>
            <AlertDialogAction onClick={go} data-testid="unsaved-leave">Salir sin guardar</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
